module.exports = __webpack_public_path__ + "static/media/netflix-icon.0d4c48ff.svg";